import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

function PositionOfOrder() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <div className="xContent p-box py-6">
          <Helmet>
        <title>Положение о награждении Орденом "Почетный деятель искусств"</title>
        <meta
        name="description"
        content='Международной Ассоциацией Деятелей Искусств'
        />
        <link rel="canonical" href="https://arts-association.com/positionoforder" />
      </Helmet>
      <div className='xContent-wrapper'>
              <div className="page-title">Положение о награждении Орденом "Почетный деятель искусств"</div>
        <div className="content">
        <div class="block">
    {/* <div class="orderImage"><img src={OrderImg} alt="Order" /></div> */}
    </div>
    <p className='has-text-centered'>Международной Ассоциацией Деятелей Искусств</p>
    <p><b>1. Общие положения</b></p>
    <p>1.1. Орден "Почетный деятель искусств" является высшей наградой, присуждаемой Международной Ассоциацией Деятелей Искусств (далее — Ассоциация) за выдающиеся достижения в области искусства и культуры.</p>
    <p>1.2. Награда вручается деятелям искусства, чьи профессиональные достижения признаны на международном или национальном уровне и оказывают значительное влияние на развитие культуры, способствуют укреплению культурных связей и обогащению культурного наследия.</p>
    <p>1.3. Орден является ежегодной наградой, и каждый год присуждается не более чем пяти лауреатам из числа кандидатов, чья кандидатура была одобрена Советом Ассоциации.</p>
    <p><b>2. Критерии для кандидатов на получение Ордена</b></p>
    <p>2.1. Кандидаты на получение Ордена "Почетный деятель искусств" должны соответствовать следующим критериям:</p>
    <ul className="goalsList">
        <li>2.1.1. <b>Исключительные достижения в области искусства</b>, которые получили признание на национальном или международном уровне.</li>
        <li>2.1.2. <b>Международное признание</b> их профессиональной деятельности, подтвержденное участием в международных конкурсах, выставках, фестивалях или публикациями в международных профессиональных изданиях.</li>
        <li>2.1.3. <b>Наличие национальных или международных наград</b> за вклад в развитие искусства и культуры.</li>
        <li>2.1.4. <b>Профессиональная репутация и признание среди коллег и экспертов</b> в своей области, подтвержденные рекомендациями членов Ассоциации или признанных международных экспертов.</li>
        <li>2.1.5. <b>Вклад в развитие и обучение новых поколений деятелей искусства</b> через образовательную деятельность (мастер-классы, тренинги, преподавание).</li>
        <li>2.1.6. <b>Публичное признание их деятельности</b>, отраженное в статьях, рецензиях, интервью или других средствах массовой информации.</li>
    </ul>
      <p><b>3. Процедура выдвижения кандидатов</b></p>
     <p>3.1. Выдвижение кандидатов на получение Ордена осуществляется действующими членами Ассоциации или признанными экспертами в области искусства.</p>
     <p>3.2. Для выдвижения кандидата необходимо представить следующие документы:</p>
     <ul className="goalsList">
        <li>3.2.1. <b>Рекомендационное письмо</b>, подписанное членом Ассоциации или международно признанным экспертом.</li>
        <li>3.2.2. <b>Подтверждающие документы</b>, свидетельствующие об исключительных достижениях кандидата (дипломы, награды, публикации, доказательства участия в международных событиях).</li>
        <li>3.2.3. <b>Портфолио</b>, содержащее описание профессиональных достижений и подтверждающее международное или национальное признание.</li>
        <li>3.2.4. <b>Биографическая справка</b>, включающая описание профессионального пути и ключевых достижений кандидата.</li>
    </ul>

      <p><b>4. Порядок голосования и принятия решения</b></p>
      <p>4.1. Рассмотрение кандидатур на получение Ордена "Почетный деятель искусств" проводится Советом Ассоциации, состоящим из не менее чем 5 членов, каждый из которых является признанным деятелем искусства с международным опытом и высокой профессиональной репутацией.</p>
      <p>4.2. Каждая кандидатура обсуждается на заседании Совета, где оцениваются представленные документы, достижения кандидата и соответствие его профессиональной деятельности установленным критериям.</p>
      <p>4.3. Решение о присуждении Ордена принимается на основании голосования членов Совета Ассоциации.</p>
      <p>4.4. Голосование является закрытым, и Орден присуждается кандидатам, которые набрали большинство голосов членов Совета.</p>
      <p>4.5. Протокол заседания Совета Ассоциации фиксирует результаты голосования.</p>
      <p><b>5. Количество награждений в год</b></p>
      <p>5.1. Орден "Почетный деятель искусств" вручается ежегодно, и количество лауреатов не может превышать пяти человек в год.</p>
      <p>5.2. В исключительных случаях Совет Ассоциации может принять решение о присуждении Ордена посмертно.</p>
      <p>5.3. Вручение Ордена происходит на официальной церемонии, организуемой Ассоциацией, с приглашением представителей международного культурного сообщества и широко освещается в средствах массовой информации.</p>
      <p><b>6. Заключительные положения</b></p>
      <p>6.1. Получение Ордена "Почетный деятель искусств" подтверждает высочайший уровень профессионализма лауреата и его признание на международном уровне.</p>
      <p>6.2. Лауреаты Ордена обязаны сохранять и укреплять международное сотрудничество в области искусства и культуры, выступая послами культуры своих стран на международной арене.</p>

      </div>
      </div>
    </div>
  );
}

export default PositionOfOrder;
